export const Price = ({
  amount,
  className,
  currencyCode = "USD",
  prefix = "",
  hidden,
}: {
  amount: number;
  className?: string;
  currencyCode: string;
  prefix?: string;
  hidden?: boolean;
} & React.ComponentProps<"p">) => (
  <p
    suppressHydrationWarning={true}
    className={className + (hidden ? " hidden" : "")}
  >
    {`${prefix}${new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount)}`}
  </p>
);
